import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'Components/UI/Button';
import { Icon } from 'Components/UI';
import Modal from 'Components/UI/Modal';
import styles from './CTAViewerUpgrade.module.scss';

import PlanoAvisoViewerUpgrade from 'Static/images/plano-aviso-viewer-upgrade.png';

interface ICTAViewerUpgrade {
  visible?: boolean;
  onCancel?: () => void;
  onConfirm: () => void;
  role?: number;
}

const CTAViewerUpgrade: FC<ICTAViewerUpgrade> = ({
  visible,
  onCancel,
  onConfirm,
  role
}) => {
  const { t } = useTranslation('federatedViewer');

  return (
    <Modal
      footerButtons={false}
      visible={visible}
      width={'auto'}
      onCancel={onCancel}
    >
      <div className={styles['wrapper']}>
        <div className={styles['imageWrapper']}>
          <img src={PlanoAvisoViewerUpgrade} alt='' />
        </div>
        <div className={styles['contentWrapper']}>
          <div>
            <label className={styles['avisoLimiteObras']}>
              {role === 1
                ? t('ctaViewer.warningAdmin')
                : t('ctaViewer.warningCompany')
              }
            </label>
          </div>
          <h2>
            {role === 1
              ? t('ctaViewer.upgradeFreeAdmin')
              : t('ctaViewer.upgradeFreeCompany')
            }
          </h2>
          <h3>{t('ctaViewer.subtitle')}</h3>

          <p>{t('ctaViewer.premiumAlsoProvides')}</p>
          <div className={styles['icons-wrapper']}>
            <div className={`${styles['icons-text-wrapper']} ${styles['icons-text-margin']}`}>
              <div>
                <Icon icon={'arquivo3d'} size={'xs'} customColor={'#8697A8'} style={{ paddingLeft: 0, marginLeft: 0 }} />
                <span>{t('ctaViewer.feature2d3d')}</span>
              </div>
              <div>
                <Icon icon={'estrelaVazia'} size={'xs'} customColor={'#8697A8'} style={{ paddingLeft: 0, marginLeft: 0 }} />
                <span>{t('ctaViewer.featureNomenclature')}</span>
              </div>
            </div>
            <div className={styles['icons-text-wrapper']}>
              <div>
                <Icon icon={'menuGerenciarUsuario'} size={'xs'} customColor={'#8697A8'} />
                <span>{t('ctaViewer.featureUsersRoles')}</span>
              </div>
              <div>
                <Icon icon={'menuPlotagem'} size={'xs'} customColor={'#8697A8'} />
                <span>{t('ctaViewer.featurePlotting')}</span>
              </div>
            </div>
            <div style={{ marginBottom: 14 }}>&nbsp;</div>
          </div>

          <div className={styles['button-wrapper']}>
            <Button
              className={styles['button-cancel']}
              type='link'
              width={190}
              height={48}
              onClick={onCancel}
            >
              {t('ctaViewer.maybeLater')}
            </Button>
            <Button
              className={styles['button-confirm']}
              type='primary'
              ispremium="true"
              width={287}
              height={48}
              onClick={onConfirm}
            >
              <Icon icon="crown" className={styles['icon']} size="xxs" color="cinzaEscuro" />
              {role === 1
                ? t('ctaViewer.acquirePremium')
                : t('ctaViewer.requestPremium')
              }
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CTAViewerUpgrade;
